var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
export var MiniStoreContext = React.createContext(null);

var Provider =
/** @class */
function (_super) {
  __extends(Provider, _super);

  function Provider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Provider.prototype.render = function () {
    return React.createElement(MiniStoreContext.Provider, {
      value: this.props.store
    }, this.props.children);
  };

  return Provider;
}(React.Component);

export { Provider };